module.exports = __webpack_public_path__ + "img/menu04a.959cbc4c.svg";